module.exports = __webpack_public_path__ + "img/bag-open-icon.9cafbb0d.png";